module.exports = __webpack_public_path__ + "static/media/rohlik.c6401ce5.jpg";